import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import State from 'store/State';
import { selectFeatureTogglesState } from 'app/store/featureToggles/selectors';
import './SupportVisualisationCurrentFeatureToggles.scss';
import { Button } from '@instinet-analytics/semantic-ui-components';
import { AutoSuggest } from '@instinet-analytics/core-lib';
import { useDispatchToggleFeatureToggle } from 'app/store/featureToggles/dispatcher';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import { WellKnownFeatureToggleKeys } from 'app/store/featureToggles/FeatureTogglesState';
import { WidgetType } from 'widgets/WidgetType';

export default function SupportVisualisationCurrentFeatureToggles() {
    const featureToggles = useSelector((state: State) =>
        selectFeatureTogglesState(state)
    );
    const [setFeatureToggleInputValue, setSetFeatureToggleInputValue] =
        useState('');
    const dispatchToggle = useDispatchToggleFeatureToggle();

    const keys = Object.keys(featureToggles);

    const toggleFeature = (feature: string) => {
        dispatchToggle(feature);
    };
    const setFeatureToggle = () => {
        toggleFeature(setFeatureToggleInputValue);
    };

    const candidates: string[] = [];
    for (const feature in WellKnownFeatureToggleKeys) {
        candidates.push(
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            (WellKnownFeatureToggleKeys as any)[feature] as unknown as string
        );
    }

    for (const widgetType in WidgetType) {
        candidates.push(`widget.${widgetType}`);
    }

    return (
        <div className="SupportVisualisationCurrentFeatureToggles">
            <div>
                <div className="form">
                    <div className="title">Set: </div>
                    <AutoSuggest
                        candidates={candidates}
                        placeholder={'Feature key'}
                        value={setFeatureToggleInputValue}
                        getComparisonString={(c) => c.toLowerCase()}
                        getCandidateValue={(c) => c}
                        onChange={setSetFeatureToggleInputValue}
                    />
                    <Button
                        primary
                        onClick={setFeatureToggle}
                        disabled={setFeatureToggleInputValue.length === 0}
                    >
                        Toggle
                    </Button>
                </div>
            </div>
            {keys.length === 0 && <div>None set</div>}
            {keys.map((feature) => (
                <div className="feature" key={feature}>
                    <div className="feature-key">{feature}</div>
                    <div>{featureToggles[feature] ? 'On' : 'Off'}</div>
                    <div className="feature-value">
                        <Icon
                            size={'big'}
                            name={
                                featureToggles[feature]
                                    ? 'toggle on'
                                    : 'toggle off'
                            }
                            onClick={() => toggleFeature(feature)}
                        />
                    </div>
                </div>
            ))}
        </div>
    );
}
